import {useMemo} from 'react';
import {useSuspenseQuery} from "@tanstack/react-query";
import {secretApi} from "../../api/api";
import sll_tournament from "../api/sll_tournament";
import {getTierScore, romanNumberConverter} from "../../function";

const UseDeeplolEvent = (event) => {
    const query = useSuspenseQuery(
        {
            queryKey: ['deeplolEvent',event],
            queryFn: async () => {
                const [eventApi, tournament] = await Promise.all([deeplolEventApi(event), sll_tournament({tournamentName: 'bjm',groupArray:['A','B','C']})])
                // const eventApi = await deeplolEventApi()
                // const tournament = await sll_tournament({tournamentName:'bjm'})
                return {...eventApi,tournament}
            },
            staleTime: Infinity,
        })


    const list = useMemo(() => {
        if (!query?.data) {
            return {}
        }
        return query.data
    }, [query.data])

    return {query, list};


};

const addTierScoreFunc = (list) => {
    return list.map((data) => {
        const splitTier = data?.tier?.split(" ");
        return {
            ...data,
            tier_score: getTierScore(`${splitTier?.[0]} ${romanNumberConverter(splitTier?.[1])}`).num,
        }
    })
}

const deeplolEventApi = async (event) => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}summoner/deeplol_event`);
        url.searchParams.set('tournament',event)
        const result = await secretApi.get(url.toString());


        const team_list = Object.entries(result.data.teams_info).map((data) => {
            return {
                team: data[0],
                players: data[1]
            }
        });


        const position = Object.entries(result.data.position_info).map((data) => {
            return {
                team: data[0],
                players: addTierScoreFunc(data[1])
            }
        });

        const teams_name = result.data.teams_name
        const group_filter = {
            A: result.data.group_filter['8강 A조'],
            B: result.data.group_filter['8강 B조']
        }

        const players_info = addTierScoreFunc(result.data?.players_info);

        return {
            team_list, position, teams_name, group_filter,players_info
        }
    } catch (e) {
        console.log(e)
        return {};
    }
}

export default UseDeeplolEvent;